// extracted by mini-css-extract-plugin
export default {"popUp":"PopUp_popUp__aXgkL","header":"PopUp_header__jim3l","message":"PopUp_message__LgDB1","buttonContainer":"PopUp_buttonContainer__6OV3a"};